<template>
  <el-table :data="tableData" :empty-text="$t('generic.noData')" :fit="true">
    <el-table-column type="expand">
      <template slot-scope="props">
        <tap-details :details="props.row"/>
      </template>
    </el-table-column>
    <el-table-column
      v-for="column in tableColumns"
      :key="column.label"
      :min-width="column.minWidth"
      :width="column.width"
      :prop="column.prop"
      :label="$t(column.label)"
      :formatter="column.formatter"
    >
    </el-table-column>

    <el-table-column width="50">
      <div slot-scope="{ row }">
        <router-link
          :to="{name: 'account-tap-details', params: {id: row.account_id, resource_id: row.id}}">
          <i class="tim-icons icon-double-right"></i>
        </router-link>
      </div>
    </el-table-column>
  </el-table>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import TapDetails from './TapDetails'

export default {
  name: 'tapsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    TapDetails
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },

  methods: {
  },
  data() {
    return {
      tableColumns: [
        {
          prop: 'operation_ts',
          label: 'tapDetails.operation_ts',
          width: 200,
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
        },
        {
          prop: 'type',
          label: 'tapDetails.type',
        },
        {
          prop: 'info.stop_id',
          label: 'tapDetails.infoDetails.stop_id',
          width: 200,
        },
        {
          prop: 'info.zone_id',
          label: 'tapDetails.infoDetails.zone_id',
          width: 200,
        },
        {
          prop: 'info.block_data_counter',
          label: 'tapDetails.block_data_counter',
          width: 200,
        },
        {
          prop: 'async',
          label: 'tapDetails.async',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.bool(cellValue)
          },
          width: 200,
        },
        {
          prop: 'info.request_id',
          label: 'tapDetails.infoDetails.request_id',
        },
      ]
    }
  }
};
</script>
<style scoped>
</style>
